module.exports = __webpack_public_path__ + "static/in-mountains-4f16e0141a1b953a9df8c3ba6b260f9c.jpg";